"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var RangePicker = antd_1.DatePicker.RangePicker;
var DlgCalculatePartnerRevshare = /** @class */ (function (_super) {
    __extends(DlgCalculatePartnerRevshare, _super);
    function DlgCalculatePartnerRevshare(props) {
        return _super.call(this, props) || this;
    }
    DlgCalculatePartnerRevshare.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.title,
                dateFrom: data.date_from,
                dateTo: data.date_to,
                noStartDate: data.no_start_date
            });
        });
        this.setState({
            visible: this.props.controller.DATA.visible,
            dialogTitle: this.props.controller.DATA.title,
            dateFrom: this.props.controller.DATA.date_from,
            dateTo: this.props.controller.DATA.date_to,
            noStartDate: this.props.controller.DATA.no_start_date
        });
        this.doReSetRules();
    };
    DlgCalculatePartnerRevshare.prototype.doReSetRules = function () {
        //this.setState({
        //    amount_rules: { isError: false },
        //})
    };
    DlgCalculatePartnerRevshare.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgCalculatePartnerRevshare.prototype.isDataValid = function () {
        this.doReSetRules();
        //if (this.state.amount < 0) {
        //    this.setState({ amount_rules: { isError: true, errorMessage: "Поле [сумма] слишком мало!" } })
        //    return false;
        //}
        //if (isNaN(this.state.amount)) {
        //    this.setState({ amount_rules: { isError: true, errorMessage: "Поле [сумма] некорректно!" } })
        //    return false;
        //}
        return true;
    };
    DlgCalculatePartnerRevshare.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.dateFrom, this.state.dateTo, this.state.noStartDate);
            }
        }
    };
    DlgCalculatePartnerRevshare.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgCalculatePartnerRevshare.prototype.onRangeChanged = function (dates, dateStrings) {
        this.setState({ dateFrom: dates[0], dateTo: dates[1] }, function () { });
    };
    DlgCalculatePartnerRevshare.prototype.render = function () {
        var _this = this;
        return (React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: false, maskClosable: false, okType: "primary", style: { minWidth: 410, width: "410px" }, width: 410 },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center" } },
                React.createElement(RangePicker, { showTime: false, format: "YYYY-MM-DD", 
                    //placeholder={[this.state.title, this.props.to.title]}
                    onChange: this.onRangeChanged.bind(this), 
                    //  onOk={this.onOkClicked.bind(this)}
                    value: [this.state.dateFrom, this.state.dateTo], 
                    //disabled={this.props.disabled}
                    style: { minWidth: "250px" } }),
                React.createElement("div", { style: { marginTop: "15px" } },
                    React.createElement(antd_1.Checkbox, { checked: this.state.noStartDate, onChange: function (e) { _this.setState({ noStartDate: e.target.checked }); } }, "\u0418\u0433\u043D\u043E\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u0430\u0442\u0443 \u043D\u0430\u0447\u0430\u043B\u0430")))));
    };
    return DlgCalculatePartnerRevshare;
}(React.Component));
exports.default = DlgCalculatePartnerRevshare;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgCalculatePartnerRevshare.tsx
// module id = 2490
// module chunks = 0